import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface StatCardProps {
  name: string;
  value: number;
  icon: LucideIcon;
  color: string;
  bgColor: string;
  testId: string;
  onClick: () => void;
}

export const StatCard = React.memo(function StatCard({
  name,
  value,
  icon: Icon,
  color,
  bgColor,
  testId,
  onClick,
}: StatCardProps) {
  return (
    <Card
      data-testid={testId}
      className="hover:bg-surface-container-low transition-colors cursor-pointer"
      onClick={onClick}
    >
      <CardContent className="p-4 sm:p-4 lg:p-6 h-full">
        <div className="flex flex-col h-full min-h-[85px] sm:min-h-[90px]">
          <p className="text-xs sm:text-sm text-muted-foreground leading-tight mb-auto">{name}</p>
          <div className="flex items-end justify-between mt-2">
            <p
              className="text-2xl sm:text-2xl lg:text-3xl font-bold"
              data-testid={`${testId}-value`}
            >
              {value}
            </p>
            <div className={`p-1.5 sm:p-2 lg:p-3 rounded-lg ${bgColor} shrink-0`}>
              <Icon className={`h-4 w-4 sm:h-5 sm:w-5 lg:h-6 lg:w-6 ${color}`} />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
});
